import { API_URL } from "../constants/constants"

// Получаем количество рефералов
export const getTransactions = async (sessionToken) => {
  try {
    const response = await fetch(`${API_URL}/web3/transactions/get`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken ? `Bearer ${sessionToken}` : "",
      },
      body: JSON.stringify({}),
    })

    const data = await response.json()

    if (data.success) {
      return data.transactions
    } else {
      throw new Error(data.error || "Failed to fetch referral stats")
    }
  } catch (error) {
    console.error("Error fetching referral stats:", error)
    return []
  }
}
